export enum EventKey {
  WithdrawalProfilesExposed = "withdrawalProfilesExposed",
  WithdrawalProfileSelected = "withdrawalProfileSelected",
  PrognosisInputInteraction = "prognosisInputInteraction",
  UserEngagements = "userEngagements",
}

export enum EventCategory {
  WithdrawalProfiles = "withdrawalProfiles",
  UserMetaInformation = "userMetaInformation",
}

export interface WithdrawalProfilesExposedEvent {
  event: EventKey.WithdrawalProfilesExposed;
  withdrawalProfiles: string[];
}

export interface WithdrawalProfileSelectedEvent {
  event: EventKey.WithdrawalProfileSelected;
  withdrawalProfile: string;
}

export interface PrognosisInputInteractionEvent {
  event: EventKey.PrognosisInputInteraction;
  pageType: string;
  element: string;
  type: string;
}

interface TestEvent {
  event: "test_event";
}

export interface UiversalEvent {
  event: string;
  eventModel: {
    event_category: string;
    event_action: string;
    event_label: string;
    event_extension?: string;
    event_loginStatus?: string;
    event_userid?: string;
  };
}

export type AnalyticsEvent =
  | WithdrawalProfilesExposedEvent
  | WithdrawalProfileSelectedEvent
  | PrognosisInputInteractionEvent
  | UiversalEvent
  | TestEvent;
